export function getAttachmentType (mimetype) {
  if (checkInput(mimetype, [
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
  ])) return 'image'
  if (mimetype === 'application/pdf') return 'pdf'
  return null
}

export function detectImageBaseOnExtension (ext) {
  return ext?.match(/.(jpg|jpeg|png|gif)$/i)
}

export function checkInput (input, words) {
  return words.some(word => new RegExp(word, 'i').test(input))
}
